import type { InvoicePayment } from '@bambi/api-client/schemas';

import { RefundPaymentCell } from './RefundPaymentCell';
import { ViewOnTilledCell } from './ViewOnTilledCell';

function ViewPaymentButton({ payment }: { payment: InvoicePayment }) {
  if (payment.is_manual) {
    return null;
  }

  return (
    <ViewOnTilledCell
      type="payments"
      resourceId={payment.external_payment_id!}
    />
  );
}

export function PaymentsActionCell({ payment }: { payment: InvoicePayment }) {
  const paymentFailed = payment.charge_status === 'failed';
  if (paymentFailed) {
    return <ViewPaymentButton payment={payment} />;
  }
  return (
    <div className="flex flex-row gap-2">
      <RefundPaymentCell payment={payment} />
      <ViewPaymentButton payment={payment} />
    </div>
  );
}
